// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api2b.pro/api",
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

// Attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Forward errors properly
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // If API returns a response, forward it; otherwise forward the error
    if (err.response) {
      return Promise.reject(err.response); // <-- forward response directly
    } else {
      return Promise.reject({
        status: 500,
        data: { message: err.message || "Network Error" },
      });
    }
  }
);

export default api;
